import { render, staticRenderFns } from "./CollegeCardKicker.vue?vue&type=template&id=bd328706"
import script from "./CollegeCardKicker.vue?vue&type=script&lang=js"
export * from "./CollegeCardKicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports